module.exports = __webpack_public_path__ + "media/svg/mail-b094953a.svg";